/**
 * Frame Options Configuration
 * Defines frame types, colors, and pricing for Gelato integration
 */

export type FrameType = 'none' | 'wood';

export interface FrameColor {
  id: string;
  name: string;
  hex: string;
}

export interface FrameOption {
  id: FrameType;
  name: string;
  description: string;
  colors: FrameColor[];
}

// Wood frame colors
export const WOOD_COLORS: FrameColor[] = [
  { id: 'black', name: 'Noir', hex: '#1a1a1a' },
  { id: 'white', name: 'Blanc', hex: '#f5f5f5' },
  { id: 'natural', name: 'Naturel', hex: '#d4a574' },
  { id: 'dark', name: 'Foncé', hex: '#3d2314' },
];

// Frame options configuration
export const FRAME_OPTIONS: FrameOption[] = [
  {
    id: 'none',
    name: 'Sans cadre',
    description: 'Poster seul, prêt à encadrer',
    colors: [],
  },
  {
    id: 'wood',
    name: 'Cadre bois',
    description: 'Cadre en pin avec plexiglas anti-reflet',
    colors: WOOD_COLORS,
  },
];

/**
 * Get available colors for a frame type
 */
export function getFrameColors(frameType: FrameType): FrameColor[] {
  const option = FRAME_OPTIONS.find(f => f.id === frameType);
  return option?.colors || [];
}

/**
 * Get frame option by ID
 */
export function getFrameOption(frameType: FrameType): FrameOption | undefined {
  return FRAME_OPTIONS.find(f => f.id === frameType);
}

/**
 * Check if frame type requires color selection
 */
export function requiresColorSelection(frameType: FrameType): boolean {
  const option = FRAME_OPTIONS.find(f => f.id === frameType);
  return (option?.colors.length || 0) > 0;
}

/**
 * Get default color for a frame type
 */
export function getDefaultFrameColor(frameType: FrameType): string {
  const colors = getFrameColors(frameType);
  return colors.length > 0 ? colors[0].id : '';
}
